import styled from 'styled-components';

export const MainImageProFeatureStyles = styled.div<{
  staticTheme?: 'dark-violet' | 'domination' | 'purple-gradient';
}>`
  body.dark & {
    --hightlighted-bg: rgba(255, 255, 255, 0.05);
    --icon-color: var(--color-white);
    --table-divider-color: #2e2246;

    ${({ staticTheme }) =>
      staticTheme === 'dark-violet' &&
      `
      --table-divider-color: #6E4690;
    `}
  }

  --hightlighted-bg: rgba(88, 0, 255, 0.05);
  --icon-color: var(--color-primary-main);
  --table-divider-color: #ebebeb;

  margin: 0;
  padding: 0 16px;

  .pro-features-table {
    width: 100%;
    max-width: 540px;
    margin: 0 auto;

    &-title--pro {
      padding: 2px 8px;
      border-radius: 4px;
      background: linear-gradient(136deg, #7f36f3 -3.67%, #ed0d80 106.36%);
    }

    tr {
      display: flex;

      &.row-list:not(:last-child) {
        border-bottom: 1px solid var(--table-divider-color);
      }

      td {
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;

        .td-icon {
          color: var(--icon-color);
        }

        &:nth-child(1) {
          flex-grow: 1;
          justify-content: flex-start;
        }

        &:nth-child(2),
        &:nth-child(3) {
          width: 60px;
        }

        &.hightlighted {
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--hightlighted-bg);

          &--first {
            border-radius: 12px 12px 0 0;
          }

          &--last {
            border-radius: 0 0 12px 12px;
          }
        }
      }
    }
  }
`;
